// Only the products spotlighted in the 3D hero viewer.
export const heroProducts = [
  { id: 1, name: 'Porsche-911',            price: 200, model: '/models/porsche-911.glb' },
  { id: 2, name: 'Axolotl Skeleton Flexi', price: 300, model: '/models/axolotl-skeleton-flexi.glb' },
  { id: 3, name: 'Articulated Octopus',    price: 300, model: '/models/octopus.glb' },
  { id: 4, name: 'F-18 Fighter Jet',       price: 200, model: '/models/f-18.glb' },
  { id: 5, name: 'Lotus Bowl',             price: 300, model: '/models/lotus_bowl.glb' },
];

// Everything you sell — used on both the homepage "Latest Prints"
// row and the full Products page. Add new items here.
export const shopProducts = [
  { id: 1, name: 'Porsche-911',            price: 200, image: '/images/products/porsche-911.png' },
  { id: 2, name: 'Axolotl Skeleton Flexi', price: 300, image: '/images/products/axolotl-skeleton-flexi.png' },
  { id: 3, name: 'Articulated Octopus',    price: 300, image: '/images/products/octopus.png' },
  { id: 4, name: 'F-18 Fighter Jet',       price: 200, image: '/images/products/f-18.png' },
  { id: 5, name: 'Lotus Bowl',             price: 300, image: '/images/products/lotus_bowl.png' },
  // { id: 6, name: 'New Product', price: 250, image: '/images/products/new-product.jpg' },
];